(() => {
  if (window.__aromelyAnnouncementPopup) {
    window.__aromelyAnnouncementPopup.refresh();
    return;
  }

  const CONFIG = '[data-aromely-announcement-popup-config]';
  const STATE = 'data-aromely-teaser-state';
  const FADE_MS = 500;
  const validId = (id) => /^[A-Za-z0-9]{1,64}$/.test(id);
  const owners = new Map();
  const teasers = new Map();
  const unloaded = new Set();
  let queued = false;
  let polling = 0;

  function restore(record) {
    clearTimeout(record.visibleTimer);
    clearTimeout(record.fadeTimer);
    record.element.removeAttribute(STATE);
    teasers.delete(record.element);
  }

  function readConfigs() {
    const next = new Map();
    document.querySelectorAll(CONFIG).forEach((node) => {
      try {
        const config = JSON.parse(node.textContent);
        const id = String(config.sectionId || '');
        const root = document.getElementById(`shopify-section-${id}`);
        if (!id || unloaded.has(id) || !root || !root.contains(node)) return;
        const formId = String(config.formId || '').trim();
        const owner = { id, root, formId, enabled: config.enabled === true, autoHide: config.autoHide === true, visibleMs: Number(config.visibleMs) === 3000 ? 3000 : 5000 };
        owner.signature = JSON.stringify([owner.formId, owner.enabled, owner.autoHide, owner.visibleMs]);
        next.set(id, owner);
      } catch {}
    });
    for (const record of teasers.values()) {
      const nextOwner = next.get(record.owner.id);
      if (!nextOwner || nextOwner.root !== record.owner.root || nextOwner.signature !== record.owner.signature) restore(record);
    }
    owners.clear();
    next.forEach((owner, id) => owners.set(id, owner));
  }

  function stillTeaser(record) {
    return record.element.isConnected && record.element.classList.contains(`kl-teaser-${record.owner.formId}`);
  }

  function shown(element) {
    if (!element.isConnected || document.visibilityState === 'hidden') return false;
    for (let node = element; node; node = node.parentElement) {
      if (node.hasAttribute('hidden') || node.getAttribute('aria-hidden') === 'true') return false;
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity || '1') <= 0) return false;
    }
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function wait(record) {
    clearTimeout(record.visibleTimer);
    record.phase = 'waiting';
  }

  function fade(record) {
    if (!stillTeaser(record)) { restore(record); return; }
    if (!shown(record.element)) {
      wait(record);
      schedule();
      return;
    }
    record.phase = 'fading';
    record.element.setAttribute(STATE, 'fading');
    record.fadeTimer = setTimeout(() => {
      if (!stillTeaser(record)) { restore(record); return; }
      record.phase = 'hidden';
      record.element.setAttribute(STATE, 'hidden');
      schedule();
    }, FADE_MS);
  }

  function scan() {
    queued = false;
    readConfigs();
    for (const record of teasers.values()) {
      if (!stillTeaser(record)) restore(record);
    }
    for (const owner of owners.values()) {
      if (!owner.autoHide || !validId(owner.formId)) continue;
      for (const element of document.getElementsByClassName(`kl-teaser-${owner.formId}`)) {
        if (!teasers.has(element)) teasers.set(element, { element, owner, phase: 'waiting' });
      }
    }
    for (const record of teasers.values()) {
      if (record.phase === 'visible' && !shown(record.element)) wait(record);
      if (record.phase === 'waiting' && shown(record.element)) {
        record.phase = 'visible';
        record.visibleTimer = setTimeout(() => fade(record), record.owner.visibleMs);
      }
    }
    const needsPolling = [...teasers.values()].some((record) => record.phase === 'waiting' || record.phase === 'visible');
    if (needsPolling && !polling) polling = setInterval(schedule, 250);
    if (!needsPolling && polling) { clearInterval(polling); polling = 0; }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(scan);
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const trigger = target?.closest('[data-klaviyo-form-id]');
    if (!trigger) return;
    const owner = [...owners.values()].find((candidate) => candidate.root.contains(trigger));
    const formId = String(trigger.dataset.klaviyoFormId || '').trim();
    if (!owner || !owner.enabled || !validId(formId)) return;
    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
  document.addEventListener('visibilitychange', schedule);
  document.addEventListener('shopify:section:load', (event) => {
    unloaded.delete(String(event.detail?.sectionId || ''));
    scan();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    unloaded.add(String(event.detail?.sectionId || ''));
    scan();
  });
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
  });
  window.__aromelyAnnouncementPopup = { refresh: scan };
  scan();
})();
